import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@mpt-fo/common/core/services/authentication.service';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';
import { ModalOptionsConfig, ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { MobileWebViewDialer } from '@mpt-fo/common/core/models/login.model';
import { DEFAULT_MODAL_KAMONA_CLASSES, DEFAULT_MODAL_WIDTH, MONIEPOINT_DESIGN_TYPE } from '@mpt-fo/common/shared/constants';
import { ScreenManagerService } from '@mpt-fo/common/core/services/screen-manager.service';
import { DataLayerService } from '@mpt-fo/common/core/services/data-layer-service.service';
import { DeviceHelperService } from '@mpt-fo/common/core/services/device-helper.service';
import { DeviceInformation } from '@mpt-fo/common/shared/models/device.model';

@Component({
	selector: 'app-username-recovery',
	templateUrl: './username-recovery.component.html',
	styleUrls: ['./username-recovery.component.scss'],
})
export class UsernameRecoveryComponent extends MobileWebViewDialer implements OnInit {
	ussdCode: any;
	loading: boolean;
	runningModal: NzModalRef;
	ROUTE = '/mobile/recovery/username';
	deviceInformation: DeviceInformation;
	constructor(
		private router: Router,
		private authService: AuthenticationService,
		private modalService: ModalService,
		private screenManager: ScreenManagerService,
		private dataLayerService: DataLayerService,
		private deviceHelper: DeviceHelperService
	) {
		super();
	}

	ngOnInit(): void {
		this.deviceInformation = this.deviceHelper.getDeviceInformation();
		if (!this.screenManager.isMobile()) {
			this.routeToWeb();
		}
		this.screenManager.isMobile$.subscribe((isMobile) => {
			if (!isMobile && this.router?.url === this.ROUTE) {
				this.routeToWeb();
			}
		});
		this.getUssd();
		const payload = this.saveLogs('sign_in_forgot_username_initiated', '', '');
		this.dataLayerService.logEvent(payload);
	}

	routeToWeb() {
		this.router.navigateByUrl('/forgot-username');
	}

	goBack() {
		this.router.navigateByUrl(`/login`);
	}

	callDialer(code) {
		this.lunchDialer(code);
	}

	handleOncloseModal() {
		this.router.navigateByUrl(`/login`);
	}

	getUssd() {
		this.loading = true;
		this.authService
			.recoverUsernameUssd()
			.then((res) => {
				this.ussdCode = res?.ussdCode;
				this.loading = false;
			})
			.catch((error) => {
				const description = StringHelper.getErrorMessageHttpErrorResponse(error);
				this.launchAlertModal({ description });
				this.loading = false;
			});
	}

	launchAlertModal(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = 'error';
		config.nzComponentParams.title = 'Request Failed';
		config.className = DEFAULT_MODAL_KAMONA_CLASSES;
		config.nzWidth = DEFAULT_MODAL_WIDTH;
		config.nzComponentParams.callback = () => {
			this.handleOncloseModal();
		};
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
		config.nzComponentParams.callbackName = params?.callbackName || 'Try Again';
		config.nzComponentParams.message = params?.description;
		this.runningModal = this.modalService.alert(config);
	}
	saveLogs(event, username, message = '') {
		const payload = new LoginEventLog(event);
		payload.device_type = this.deviceInformation?.model?.toString()?.toUpperCase();
		payload.device_id = this.deviceInformation?.deviceUniqueIdentifier;
		payload.error_message = message;
		payload.user_name = username;
		return payload;
	}
}

export class LoginEventLog {
	event: string;
	step: string;
	'device_type': string;
	'device_id': string;
	'error_message': string;
	'onboarding_mode': string;
	'user_name': string;

	constructor(event) {
		this.event = event;
	}
}
